/**
 * @module User
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from '../../helpers/helper'

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        userData: [],
        myErrors: [],
        errorMsg: '',
        stepLogin: 0,
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        userDataSet: function (state, data) {
            state.userData = data;
        },

        stepLoadingLoginSet: function(state, data)
        {
            state.stepLogin = data.step;
            state.errorMsg = data.msg;
        }
    },

    actions: {
        destroyToken: function () {
            localStorage.removeItem('access_token');
            localStorage.removeItem('ur_part');
            localStorage.removeItem('ur_modulo');
            localStorage.removeItem('ur_risorsa');
            localStorage.removeItem('ur_deadline');
            localStorage.removeItem('ur_sidebar');
            localStorage.removeItem('ur_user_id');

        },

        redirectToLogin: function () {
            window.location.href = '/login';
        },

        getUserData: function (state) {
            axios.get('/api/v1/user')
                .then(function (response) {
                    state.commit('userDataSet', response.data);
                })
                .catch(function (error) {
                    state.dispatch('destroyToken');
                    state.dispatch('redirectToLogin');
                })
        },

        logout: function (state) {
            axios.get('/api/v1/user/logout')
                .then(function (response) {
                    state.dispatch('destroyToken');
                    state.dispatch('redirectToLogin');
                });


        },

        checkLogin: function (state, data) {
            state.commit('stepLoadingLoginSet', {step: 1, msg: ''});
            //state.dispatch('registerUser', data);
            state.dispatch('checkWPLogin', data);
        },

        checkPassportLogin: function (state, data) {
            state.dispatch('destroyToken');
            axios.post('/oauth/token', {
                username: data.email,
                password: data.password,
                client_id: 2,
                client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
                grant_type: 'password'
            })
                .then(function (response) {
                    localStorage.setItem("access_token", response.data.access_token);
                    window.location.href = '/login_cr';
                    //state.dispatch('checkWPLogin', data);
                })
                .catch(function (error) {

                })
        },

        checkWPLogin: function (state, data) {
            axios.post('/api/v1/wpauth', {
                email: data.email,
                password: data.password,
            })
                .then(function (response) {
                    if (response.data !== false) {
                        state.dispatch('registerUser', data);
                    }
                    else {
                        state.commit('stepLoadingLoginSet', {step:0, msg: 'Ooops! Email o Password errati.'});

                    }
                })
                .catch(function (error) {
                    console.log(error);
                    state.commit('stepLoadingLoginSet', {step: 0, msg: 'Ooops! Email o Password errati.'});

                })
        },

        registerUser: function (state, data) {
            axios.post('api/v1/user/register', {
                email: data.email,
                password: data.password,
            })
                .then(function (response) {
                    state.dispatch('checkPassportLogin', data);
                })
                .catch(function (error) {

                })
        },

        checkErrorMessage: function (state, error) {
            if (error.status == 401) {
                state.dispatch('destroyToken');
                state.dispatch('redirectToLogin');
            }
        },

        getUserRole: function (state) {
            axios.get('/api/v1/user/checkRole')
                .then(function (response) {
                    localStorage.setItem("ur_part", JSON.stringify(response.data.part));
                    localStorage.setItem("ur_modulo", JSON.stringify(response.data.modulo));
                    localStorage.setItem("ur_risorsa", JSON.stringify(response.data.risorsa));
                    localStorage.setItem("ur_sidebar", JSON.stringify(response.data.sidebar));
                    localStorage.setItem("ur_deadline", JSON.stringify(response.data.deadline));
                    localStorage.setItem('ur_user_id', JSON.stringify(response.data.user_id));
                    localStorage.setItem('ur_email', JSON.stringify(response.data.email));
                    window.location.href = '/dashboard';
                }).catch(error => {
                if (error.response) {
                    state.dispatch('user/checkErrorMessage', error.response, {root: true});
                }
            });
        }


    }
}